<template>
  <div class="page-container">
    <el-tree
      :data="navigationTree"
      ref="navTree"
      node-key="id"
      :props="defaultProps"
      default-expand-all
      :expand-on-click-node="false"
      v-loading="loading"
    >
      <span class="custom-tree-node" slot-scope="{ data }">
        <span class="span1">{{ data.title }}</span>
        <span class="span2">{{ data.name }}</span>
        <span class="span3">{{ data.linkUrl }}</span>
        <span class="span3">{{ data.sortId }}</span>
        <span class="span4">
          <el-button
            type="primary"
            size="mini"
            icon="el-icon-plus"
            @click="() => addChildren(data)"
          >
            添加
          </el-button>
          <el-button
            type="success"
            size="mini"
            icon="el-icon-edit"
            @click="edit(data)"
            v-if="data.parentId"
            >编辑</el-button
          ><el-button
            type="warning"
            size="mini"
            icon="el-icon-share"
            @click="configPower(data)"
            v-if="data.children && data.children.length == 0"
            >关联按钮</el-button
          ><el-button
            type="danger"
            size="mini"
            icon="el-icon-delete"
            @click="deletedMenu(data)"
            v-if="data.id != 1"
            >删除</el-button
          >
        </span>
      </span>
    </el-tree>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="handleClose" 
      
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="上级导航" prop="parentId">
          <el-col :span="10">
            <treeselect
              :options="navigationTree"
              :value="form.parentId"
              :normalizer="normalizer"
              :show-count="true"
              :clearable="false"
              @select="orgTreeSelected"
              placeholder="请选择"
            />
          </el-col>
        </el-form-item>
        <el-form-item label="导航名称" prop="title">
          <el-input type="text" v-model="form.title"></el-input>
        </el-form-item>
        <el-form-item label="别名" prop="name">
          <el-input type="text" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="链接地址" prop="linkUrl">
          <el-input type="text" v-model="form.linkUrl"></el-input>
        </el-form-item>
        <el-form-item label="排序号" prop="sortId">
          <el-input type="text" v-model="form.sortId" maxlength="5" oninput="value=value.replace(/[^\d]/g,'')"></el-input>
        </el-form-item>
        <el-form-item label="导航图标" prop="iconUrl">
          <el-input type="text" v-model="form.iconUrl"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="configTitle"
      :visible.sync="dialogConfig"
      :close-on-click-modal="false"
      width="700px"
      @close="handleClose"
      :center="true" 
      
    >
      <el-form :model="menuSubmit" ref="form" label-width="100px">
        <el-form-item label="权限按钮：" prop="remark">
          <el-checkbox-group v-model="menuBtns">
            <el-checkbox
              v-for="item in menuList"
              :label="item.id"
              :key="item.id"
              >{{ item.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogConfig = false">取 消</el-button>
        <el-button type="primary" @click="saveConfig">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSystemAllNavList,
  getSystemMenuBtn,
  saveSystemMenuBtn,
  updateSystemMenuBtn,
  distributeNavigationMenu,
  getNavigationMenuBtn,
  deletedMenu,
} from "@/common/api.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  props: {},
  data() {
    return {
      loading: false,
      dialogVisible: false,
      dialogConfig: false,
      navigationTree: [],
      menuList: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      normalizer(node) {
        if (
          node.children == null ||
          node.children == "null" ||
          node.children.length == 0
        ) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.title,
          children: node.children,
        };
      },
      menuBtn: [],
      form: {
        id: null,
        parentId: null,
        sortId: null,
        title: "",
        name: "",
        linkUrl: "",
        iconUrl: "",
        remark: "",
        navType: "system",
      },
      // 弹出层标题
      title: "",
      //表单验证
      rules: {
        parentId: [
          { required: true, message: "请选择上级导航", trigger: "blur" },
        ],
        name: [{ required: true, message: "请填写导航名称", trigger: "blur" }],
        title: [{ required: true, message: "请填写导航别名", trigger: "blur" }],
      },
      menuBtns: [],
      configTitle: "",
      //关联按钮提交from
      menuSubmit: {
        id: "",
        menuBtns: [],
      },
    };
  },
  watch: {},
  methods: {
    // 获取导航菜单tree
    getSystemAllNavList() {
      var data = {
        navType: "system",
      };
      this.navigationTree = [];
      this.loading = true;
      getSystemAllNavList(data).then((res) => {
        this.loading = false;
        console.log(res.data);
        if (res.errorCode == 200) {
          if (res.data) {
            this.navigationTree.push(res.data);
            console.log(this.navigationTree);
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 获取按钮列表
    getSystemMenuBtn() {
      getSystemMenuBtn().then((res) => {
        if (res.errorCode == 200) {
          this.menuList = res.data;
        }
      });
    },
    // 获取菜单分配的按钮
    getNavigationMenuBtn(id) {
      console.log();
      var data = {
        id: id,
      };
      this.menuBtns = [];
      getNavigationMenuBtn(data).then((res) => {
        this.loading = false;
        console.log(res.data);
        if (res.errorCode == 200) {
          if (res.data) {
            if (res.data.menuBtns && res.data.menuBtns.length > 0) {
              for (let k in res.data.menuBtns) {
                this.menuBtns.push(res.data.menuBtns[k].id);
              }
              console.log(this.menuBtns);
            } else {
              this.menuBtns = [];
            }
          }
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleAdd() {},
    // 新增导航菜单
    addChildren(data) {
      this.reset();
      this.title = "新增导航菜单";
      this.dialogVisible = true;
      console.log(data);
      if (data) {
        this.form.parentId = data.id;
      }
    },
    // 编辑导航菜单
    edit(data) {
      this.reset();
      console.log(data);
      this.title = "编辑导航菜单";
      this.dialogVisible = true;
      this.form = {
        id: data.id,
        parentId: data.parentId,
        title: data.title,
        name: data.name,
        linkUrl: data.linkUrl,
        iconUrl: data.iconUrl,
        remark: data.remark,
      };
    },
    // 保存
    saveAddOrEdit() {
      console.log(this.form);
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            updateSystemMenuBtn(this.form).then((res) => {
              if (res.errorCode == "200") {
                this.getSystemAllNavList();
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          } else {
            saveSystemMenuBtn(this.form).then((res) => {
              if (res.errorCode == "200") {
                this.getSystemAllNavList();
                this.dialogVisible = false;
                this.$message({
                  type: "success",
                  message: "保存成功",
                });
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        }
      });
    },
    // 删除导航菜单
    deletedMenu(data) {
      console.log(data);
      var params = {
        id: data.id,
      };
      this.$confirm("此操作将删除本导航即下属导航, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(12323123123);
          deletedMenu(params).then((res) => {
            if (res.errorCode == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getSystemAllNavList();
            }else{
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {
          console.log("quxiao");
          // this.$message({
          //   type: "warning",
          //   message: "已取消删除",
          // });
        });
    },
    // 关联按钮
    configPower(data) {
      console.log(data);
      this.dialogConfig = true;
      this.configTitle = data.title;
      this.menuSubmit.id = data.id;
      if (data.menuBtns && data.menuBtns.length > 0) {
        this.menuBtns = [];
        data.menuBtns.map((item) => {
          this.menuBtns.push(item.id);
        });
        this.menuBtns = data.menuBtns;
        this.getNavigationMenuBtn(data.id);
      } else {
        this.menuBtns = [];
      }
    },
    // 保存关联按钮
    saveConfig() {
      console.log(this.menuBtns);
      // this.loading = true;
      if (this.menuBtns.length > 0) {
        this.menuSubmit.menuBtns = [];
        for (let k in this.menuBtns) {
          this.menuSubmit.menuBtns.push({ id: this.menuBtns[k] });
        }
        distributeNavigationMenu(this.menuSubmit).then((res) => {
          if (res.errorCode == "200") {
            this.getSystemAllNavList();
            this.dialogConfig = false;
            this.loading = false;
            this.$message({
              type: "success",
              message: "保存成功",
            });
          } else {
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("请选择按钮");
      }
    },
    closeDialog() {},
    handleClose() {},
    //选择所属机构
    orgTreeSelected(node) {
      console.log(node);
      this.form.parentId = node.id;
      console.log(this.form);
    },

    // 表单数据清空
    reset() {
      this.form = {
        id: null,
        parentId: null,
        title: "",
        name: "",
        linkUrl: "",
        iconUrl: "",
        remark: "",
        sortId: null,
      };
    },
    //弹框关闭 重置form
    handleClose() {
      this.$nextTick(() => {
        this.$refs["form"].resetFields();
      });
    },
  },
  created() {},
  mounted() {
    this.getSystemAllNavList();
    this.getSystemMenuBtn();
  },
  computed: {},
};
</script>
<style lang="less" scoped>
.page-container {
  height: 100%;
  margin-top: 20px;
  .el-row {
    margin: 10px 0 0 !important ;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    background-color: #ffffff;
    padding: 5px 15px 0;
    border-bottom: solid 1px #ebeef5;
    .add-btn {
      float: left;
      padding: 0;
      margin-top: 5px;
      margin-bottom: 10px;
      .el-button {
        padding: 8px 15px;
        font-size: 12px;
        border-radius: 3px;
      }
    }
    .btn-group-right {
      float: right;
      .el-button {
        padding: 8px;
      }
    }
    .btn-group-right {
      margin-top: 5px;
      span {
        display: inline-block;
        vertical-align: top;
        font-size: 20px;
        padding: 8px;
      }
    }
  }
  .config-title {
    padding-bottom: 20px;
    text-align: center;
    font-size: 18px;
    font-weight: 600;
  }
  .custom-tree-node {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .edit-button {
      margin-right: 15px;
    }
  }
  .el-tree {
    padding-top: 20px;
    padding-right: 10px;
    .el-button--mini {
      padding: 2px 3px;
      margin-right: 5px;
    }
  }
  /deep/.el-tree-node__content,
  /deep/.el-tree-node {
    margin-bottom: 5px;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/system/menuManage/navigationSystemPage.vue